import React from 'react'
import Register from '../components/Register'

function RegisterScreen() {
  return (
    <div>
        <Register/>
    </div>
  )
}

export default RegisterScreen